import * as React from 'react';
import { Flex, FlexItem, Tooltip } from '@patternfly/react-core';
import { FlagLevelIcon } from '@app/components/FlagLevelIcon';
import { FLAG_LEVELS_BY_SEVERITY, Flag, getFlagLevelConfig } from '@app/model/Flag';

interface KlassFlagSummaryProps {
  flags?: Flag[];
  salient?: boolean; // New prop: if true, hide component when no flags exist
}

export const KlassFlagSummary: React.FC<KlassFlagSummaryProps> = ({ flags: flags = [], salient = false }) => {
  if (!flags || flags.length === 0) {
    // If salient is true, render nothing. 
    // Otherwise, show the smiley face as the "empty" state.
    if (salient) {
      return null;
    }
    return (
      <span 
        style={{ color: 'var(--pf-v6-global--Color--200, #6a6e73)', cursor: 'default' }} 
        role="img" 
        aria-label="no flags"
        title="no flags"
      >
        🙂
      </span>
    );
  }

  const renderTooltipContent = (flagList: Flag[], levelName: string) => (
    <div style={{ textAlign: 'left' }}>
      <strong>{levelName} Flags:</strong>
      <ul style={{ paddingLeft: '1rem', margin: '4px 0 0 0', listStyleType: 'disc' }}>
        {flagList.map((f, i) => (
          <li key={i}>{f.flagName}</li>
        ))}
      </ul>
    </div>
  );

  return (
    <Flex spaceItems={{ default: 'spaceItemsMd' }} alignItems={{ default: 'alignItemsCenter' }}>
      {FLAG_LEVELS_BY_SEVERITY.map(level => {
        const levelFlags = flags.filter(f => f.flagLevel === level);
        if (levelFlags.length === 0) {
          return null;
        }
        const { text } = getFlagLevelConfig(level);
        return (
          <FlexItem key={level}>
            <Tooltip content={renderTooltipContent(levelFlags, text)}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '4px', cursor: 'help' }}>
                <FlagLevelIcon level={level} />
                <strong>{levelFlags.length}</strong>
              </div>
            </Tooltip>
          </FlexItem>
        );
      })}
    </Flex>
  );
};
